export default "__VITE_ASSET__7474d93a__"